<template lang="html">
  <v-list two-line avatar>
    <!-- <v-list-item v-for="(item, index) in list_items" :key="index"
    @click="setProjectMembersSelectedIndex(index)"
    :style="getProjectMembersSelectedIndex === index? 'background-color: #616161':''"> -->
    <v-list-item v-for="(item, index) in list_items" :key="index"
      :style="getSelectedProjectDataIndex === index ? 'background-color: #616161' : ''"
      @click="setSelectedProjectDataIndex(index)">
      <v-list-item-avatar color="grey">
        <v-icon medium> {{ item.icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          :color="getProjectDataEditing === item.name ? 'green': 'blue'"
          icon
          @click="toggleEditMode(item.name)"
          v-if="getSelectedProjectDataIndex === index &&
                hasProjectPermission({
              project_id: $route.params.project_id,
              ppermission: 'Update Project information'
            })
          "
        >
          <v-icon>{{getProjectDataEditing === item.name ? 'check':'edit'}}</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  props: [],
  data: function () {
    return {
      list_items: [
        {
          icon: 'home',
          name: 'Address'
        },
        {
          icon: 'money',
          name: 'Invoice Address'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('View', [
      'getSelectedProjectDataIndex',
      'getProjectDataEditing'
    ]),
      ...mapGetters('Project', [
    'hasProjectPermission'
  ])
  },
  methods: {
    toggleEditMode(name){
      if (this.getProjectDataEditing === name) {
        if (name === 'Address') {
          this.updateProjectAddress({
            project_id: this.$route.params.project_id
          });
        }
        if (name === 'Invoice Address') {
          this.updateProjectInvoiceAddress({
            project_id: this.$route.params.project_id
          });
        }

      } else {
        this.setProjectDataEditing(name);
      }
    },
    ...mapActions('View', [
      'setSelectedProjectDataIndex',
      'setProjectDataEditing',
    ]),
    ...mapActions('Project', [
      'updateProjectAddress',
      'updateProjectInvoiceAddress'
    ])
  }
}
</script>

<style lang="css" scoped>
</style>
